export default ":host {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  padding: var(--card-padding);\n}";